import { ParamKeyValue } from "./ParamKeyValue";



export class DynamicControlDescriptor {
  controlType: string;
  parameters:ParamKeyValue[];

}
